export const buildErrorMsg = (errors) => Object.values(errors).join(',');
